import { enableProdMode } from '@angular/core';

import { environment } from './environments/environment';
import { BootStrapApplication } from './app/bootstrap-application';

if (environment.production) {
  enableProdMode();
}

BootStrapApplication();
